<template>
  <div class="video-container">
    <div class="video-wrapper">
      <video
        ref="videoPlayer"
        :src="videoUrl"
        controls
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        @loadedmetadata="onLoadedMetadata"
        @error="onVideoError" />
    </div>
    <div v-if="error" class="error-message">
      视频加载失败，请稍后重试
    </div>
  </div>
</template>

<script>
import { getQueryString } from '@/common/tools'

export default {
  name: 'CMSVideo',
  data () {
    return {
      videoUrl: 'https://files.souji168.cn/uploads/20250407/730a4cd7566b5fa36b61a267f342ac6f.mp4',
      error: false,
      originalTitle: document.title
    }
  },
  mounted () {
    // 检查是否有通过URL参数传入的视频地址
    const videoParam = getQueryString('video')
    if (videoParam) {
      this.videoUrl = decodeURIComponent(videoParam)
    }

    // 设置页面标题
    document.title = '视频播放'

    // 监听全屏变化事件，适配不同浏览器
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.onFullscreenChange)
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
    document.addEventListener('MSFullscreenChange', this.onFullscreenChange)

    // 适配微信等webview环境
    this.handleWebView()
  },
  beforeDestroy () {
    // 移除事件监听器
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.onFullscreenChange)
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
    document.removeEventListener('MSFullscreenChange', this.onFullscreenChange)

    // 恢复原始标题
    document.title = this.originalTitle
  },
  methods: {
    onLoadedMetadata () {
      // 视频加载成功
      this.error = false
    },

    onVideoError () {
      // 视频加载失败
      this.error = true
      console.error('视频加载失败')
    },

    onFullscreenChange () {
      // 处理全屏状态变化
      const isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )

      // 在全屏状态下可以进行一些特殊处理
      if (isFullscreen) {
        console.log('进入全屏模式')
      } else {
        console.log('退出全屏模式')
      }
    },

    handleWebView () {
      // 检查是否在webview环境中
      const ua = navigator.userAgent.toLowerCase()
      const isWebView = /(micromessenger|qq|alipay|baidu)/i.test(ua)

      if (isWebView) {
        // 针对webview环境的特殊处理
        console.log('在webview环境中')

        // 某些webview可能需要特殊的全屏处理
        // 这里可以添加针对特定webview的兼容性代码
      }
    },

    // 手动触发全屏（如果需要）
    enterFullscreen () {
      const video = this.$refs.videoPlayer
      if (video.requestFullscreen) {
        video.requestFullscreen()
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen()
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen()
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.video-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video-wrapper {
  width: 100%;
  max-width: 800px;
  position: relative;
  aspect-ratio: 16 / 9; /* 保持视频比例 */
}

video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
}

.error-message {
  color: #fff;
  font-size: 16px;
  padding: 20px;
  text-align: center;
}

/* 适配移动端全屏显示 */
@media screen and (max-width: 768px) {
  .video-wrapper {
    max-width: 100%;
  }
}

/* 解决某些浏览器全屏样式问题 */
:fullscreen .video-container,
:-webkit-full-screen .video-container,
:-moz-full-screen .video-container {
  background-color: #000;
}

:fullscreen video,
:-webkit-full-screen video,
:-moz-full-screen video {
  width: 100%;
  height: 100%;
}
</style>
